module.exports = __webpack_public_path__ + "img/Jingjing_Chen@2x.98eaf18a.png";